import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeMultipleHierarchyPicker } from '../../common';
import { CodeMultiplePickerProps } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { LoadCodetableOptions, SlotProps } from 'app/area/codetable/item/types';
import { RefObject } from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';
import { getValidationWithoutDuplicates } from 'app/area/codetable/item/code-pickers/helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeCodetableTypes = (props: CodeMultiplePickerProps & SlotProps
  & { loadCodetableOptions: LoadCodetableOptions }
  & { sectionRef?: RefObject<HTMLDivElement>; readonly?: boolean; locale: string }) => {

  const { breadcrumbs, metadata, codeItem, onChange, options, loadCodetableOptions,
    translation, locale, sectionRef, readOnly, displaySelectAll, validation, sectionSlots } = props;

  if (!(metadata && metadata.codetableClass && isDefinedIncludingZero(metadata.codetableClass.id))) {
    return null;
  }

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, metadata.codetableClass.id, loadOptionsParams);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, metadata.codetableClass.id, breadcrumbs);

  const typeOptions = (!!options && !!options.codetableTypes && options.codetableTypes.codes || []) as CodeComplexValue<number>[];
  const codeTypeValidation = !!validation && !!validation.class ? getValidationWithoutDuplicates(validation.class) : undefined;

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="types"
      validation={undefined}
      info={{ text: translation.types }}
      label={{ visible: true, text: translation.types }} />
    <MainGridContainer>
      <div className="row">
        {renderSlot(sectionSlots, 'top', props)}
        <CodeMultipleHierarchyPicker
          id="codetableTypes"
          label={translation.types}
          valueItems={codeItem && codeItem.codetableTypes}
          readOnly={readOnly}
          extraFooterButton={extraFooterButton}
          options={typeOptions}
          fetchingOptions={options && options.codetableTypes && options.codetableTypes.fetching}
          displaySelectAll={displaySelectAll}
          searchRequired={metadata.codetableClass.searchRequired}
          translation={translation}
          validation={codeTypeValidation}
          locale={locale}

          onLoadOptions={onLoadOptions}
          onChange={onChange}
        />
        {renderSlot(sectionSlots, 'bottom', props)}
      </div>
    </MainGridContainer>
  </div>;
};
